import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';

class BudgetSourceAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'BudgetSources';

  /**
   * Get dữ liệu chuyển từ nguồn
   * @returns
   */
  async fromBudgetSource(param = {}) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/list',
      data: {
        Skip: 0,
        Take: 100,
        Sort: 'budget_source_code',
        Columns: 'budget_source_name,budget_source_code,budget_source_id',
        Filter: '[{"Field":"parent_id","Operator":"NOT NULL"}]',
        type: 0,
        ...param,
      },
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Get dữ liệu chuyển từ nguồn
   * @returns
   */
  async changeBudgetSource(param) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/changeBudgetSource',
      data: {
        ...param,
      },
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Get dữ liệu chuyển từ nguồn
   * @returns
   */
  async GetAccountDefaultByBudgetSource(budgetSourceId) {
    let request = {
      url: [this.getAPIUrl(), `GetAccountDefaultByBudgetSource?BudgetSourceId=${budgetSourceId}`].join('/'),
    };
    return await httpClient.getAsync(request);
  }

  /**
   * Lấy nguồn kinh phí chi tiết
   * @returns
   * ttanh1 7/2/2023
   */
  async getBudgetSourceMappingToExport() {
    let request = { url: [this.getAPIUrl(), 'budgetSourceMappingToExport'].join('/') };
    return await httpClient.getAsync(request);
  }

  /**
   * Lưu danh mục nguồn mapping
   * @param {*} data
   * @returns
   */
  async savebudgetSourceMappingToExport(data) {
    let request = {
      url: [this.getAPIUrl(), 'savebudgetSourceMappingToExport'].join('/'),
      data: {
        Data: data,
      },
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Lấy nguồn KP mapping cho nộp báo cáo lên cấp trên
   * @returns
   */
  async getBudgetSourceMappingToExportX1Online(payload) {
    let request = {
      url: [this.getAPIUrl(), 'budgetSourceMappingToExportX1Online'].join('/'),
      data: payload,
    };

    return await httpClient.postAsync(request);
  }
}

export default new BudgetSourceAPI();
